export default __webpack_public_path__ + "static/media/b-6.83cc1789.svg";